declare const __translate: { [name: string]: string };

export function translate(name: string): string {
  return __translate[name] ?? name;
}
